import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";
import { Icon } from "@iconify-icon/solid";
import { cn } from "@/libs/cn";

export function TextInput(props) {

  const onInput = (ev) => {
    props?.input(props.name, ev.target.value);
  }

  const onKeyUp = (ev) => {
    if (props.keyaction) {
      props?.keyaction(ev);
    }
  }

  const onKeyDown = (ev) => {
    if (props.submitOnEnter && ev.key === 'Enter') {
      props?.submit();
    }
  }

  return (
    <TextFieldRoot name={props.name} class={cn("space-y-0", props.class)}>
      <TextFieldLabel class={props.sr ? 'sr-only mb-0' : ''}>{props.label}</TextFieldLabel>
      <div class="relative">
        <TextField
          class={cn("mt-[0px]", props.inputClass)}
          placeholder={props.placeholder ?? ''}
          type={props.type ?? 'text'}
          autoCapitalize="none"
          autocorrect="off"
          disabled={props.loading || props.disabled}
          value={props.form[props.name]}
          onChange={onInput}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          readOnly={props.readOnly}
          max={props.max}
          min={props.min}
        />
        <Show when={props.icon ?? false}>
          <Icon icon={props.icon} width="21" height="21" onClick={props.iconOnClick ?? {}} class="absolute right-3 cursor-pointer top-1/2 transform -translate-y-1/2" />
        </Show>
      </div>
    </TextFieldRoot>
  );
}

export function InputRoot(props) {
  return (
    <TextFieldRoot class={cn("space-y-0", props.class)}>
      <TextFieldLabel class={props.sr ? 'sr-only mb-0' : ''}>{props.label}</TextFieldLabel>
      {props.children}
    </TextFieldRoot>
  );
}

export function DivTextBox(props) {
  return (
    <div class={cn("flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-shadow file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[1px] focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", props.class)}>
      {props.children}
    </div>
  );
}

export function DivInput(props) {
  return (
    <InputRoot class={props.rootClass} label={props.label}>
      <DivTextBox class={props.class}>
        {props.children}
      </DivTextBox>
    </InputRoot>
  );
}
